
import { useStore } from "@/store";
import { computed, defineComponent, ref } from "vue";
import { MutationTypes } from "@/store/player/mutation-types";
import GoodItem from "../Pack/GoodItem.vue";
import { OptionsDataType } from "@/const/indexedDB";
import { SysActionTypes } from "@/store/sys/action-types";
const store = useStore();
export default defineComponent({
  name: "TabBox",
  components: {
    GoodItem
  },
  setup() {
    const activeTab = ref("all");
    const packItemList = computed(() => {
      return store.state.userPackage;
    });
    const filterPackItemList = computed(() => {
      return packItemList.value.filter(m => {
        if (activeTab.value === "all") {
          return true;
        } else {
          return m.type === activeTab.value;
        }
      });
    });
    const userMoney = computed(() => {
      return store.state.userInfo.money;
    });
    const handleSellAll = () => {
      let money = 0;
      const sellMulty = filterPackItemList.value
        .filter(({ isLock, grade }) => !isLock && grade < 4)
        .map(({ id, count, price, type }) => {
          money += price * count;
          if (["equipment"].includes(type)) {
            const params: OptionsDataType = {
              index: id
            };
            store.dispatch(SysActionTypes.SYS_DEL_EQUIP, params);
          }
          return {
            id,
            count
          };
        });
      store.commit(MutationTypes.REMOVE_ITEM_TO_PACKAGE_MUL, sellMulty);
      store.commit(MutationTypes.MAKE_MONEY, money);
    };
    const handleTidy = () => {
      store.commit(MutationTypes.TIDY_PACKAGE);
    };
    return {
      activeTab,
      packItemList,
      filterPackItemList,
      userMoney,
      handleSellAll,
      handleTidy,
      tabList: [
        {
          key: "all",
          name: "全部"
        },
        {
          key: "equipment",
          name: "装备栏"
        },
        {
          key: "consumables",
          name: "消耗品"
        }
      ]
    };
  }
});
